var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 1v1h-.5C1.676 2 1 2.676 1 3.5v9c0 .824.676 1.5 1.5 1.5h10c.824 0 1.5-.676 1.5-1.5v-9c0-.824-.676-1.5-1.5-1.5H12V1h-1v1H4V1H3Zm-.5 2H3v1h1V3h7v1h1V3h.5c.281 0 .5.219.5.5V5H2V3.5c0-.281.219-.5.5-.5ZM2 6h11v6.5c0 .281-.219.5-.5.5h-10a.494.494 0 0 1-.5-.5V6Zm6 2v3h3V8H8Zm1 1h1v1H9V9Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export default ForwardRef;